import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history',
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const token = getCookie("token");
  const requiresAuth = to.matched.some(r => r.meta && r.meta.requiresAuth);

  if (requiresAuth && !token) {
    // сохраняем полный путь
    localStorage.setItem("after_login_redirect", to.fullPath);
    return next({ path: "/authentication" });
  }

  // если уже залогинен и открывает стр авторизации, то редирект назад
  if (to.path === "/authentication" && token && localStorage.getItem('current_user')) {
    const redirect = localStorage.getItem("after_login_redirect");
    localStorage.removeItem("after_login_redirect");
    return next(redirect || "/profile");
  }

  next();
});

function getCookie(name) {
  const m = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([$?*|{}\\[\\]\\\\^])/g, "\\$1") + "=([^;]*)")
  );
  return m ? decodeURIComponent(m[1]) : null;
}

export default router;
